/**
 * Byte-identical port of the AngularJS `dateSerializer` factory
 * (account-v1/src/core/serializers/serializers.js): a `Date` → `'YYYY-M-D'`
 * (no zero-padding), `null` for a falsy date. Stateless, no Angular deps.
 *
 * Replaces the `$injector.get('dateSerializer')` bridge for the 4
 * native consumers (admin-reports / journeys / big-picture / audiences). Imported
 * by its direct sub-path (not the eval-order-fragile account-shared barrel). The
 * AngularJS factory stays registered for account-v1-internal callers (WS5).
 */
export function dateSerialize(date: any): string | null {
  if (!date) return null;
  return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
}
